import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import './headerlibros.css';

const HeaderLibros = () => {
    const [t, i18n] = useTranslation("biblioteca");
    const [t2] = useTranslation("home");

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Biblioteca',
            event_label: label,
            value: 1
        });
    };

    return (
        <div className="_ngcontent-ng-c168712225">
            <header class="biblioteca-header">
                <div class="biblioteca-header__inner">
                    <h1 class="biblioteca-header__title">{t("2026.title")}</h1>
                    <nav aria-label="Categorías" class="biblioteca-header__categories">
                        <a onClick={() => trackAnalyticsClick('Biblioteca - Mis libros')}

                            class="biblioteca-header__category biblioteca-header__category--active"
                            href={"/" + i18n.language + "/biblioteca"}> {t2("2026.leyenda-btn")} </a>
                        <a onClick={() => trackAnalyticsClick('Biblioteca - Recomendados')}
                            class="biblioteca-header__category"
                            href={"/" + i18n.language + "/recomendados"}> {t2("2026.leyenda-btn2")} </a>

                    </nav>
                    <div aria-label="Controles de biblioteca" class="biblioteca-header__controls libreria-invisible">
                        <label class="biblioteca-header__control biblioteca-header__control--sort">
                            <span class="biblioteca-header__visually-hidden">Ordenar por</span>
                            <select>
                                <option value="Ordenar por">Ordenar por</option>
                                <option value="Más recientes">Más recientes</option>
                                <option value="Más antiguos">Más antiguos</option>
                                <option value="Título A-Z">Título A-Z</option>
                                <option value="Título Z-A">Título Z-A</option>
                            </select>
                        </label>
                        <div class="biblioteca-header__control biblioteca-header__control--search">
                            <label>
                                <span class="biblioteca-header__visually-hidden">Buscar</span>
                                <input type="search" placeholder="Buscar"/>
                                    <button type="button" aria-label="Buscar" class="biblioteca-header__search-button">
                                        <img src="/logos/logo_search.svg" alt="Compartir en redes" aria-hidden="true"/>
                                    </button>
                            </label>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    );
};

export default HeaderLibros;